(() => {
  if (window.coveraxCartFlyReady) return;
  window.coveraxCartFlyReady = true;

  let pendingFlight = null;

  const getVariantImage = (productRoot) => {
    const selectedVariant = productRoot.querySelector('[data-variant-card].is-selected');
    const mediaId = selectedVariant?.dataset.mediaId;
    const mediaImage = mediaId
      ? productRoot.querySelector(`[data-pdp-slide][data-media-id="${CSS.escape(mediaId)}"] img`)
      : null;
    const image = mediaImage || productRoot.querySelector('.coverax-pdp__slide.is-active img');

    return image?.currentSrc || image?.src || '';
  };

  const getPopupImage = (form) => {
    const image = form.closest('.cart-popup-card')?.querySelector('.cart-popup-card__image');
    return image?.currentSrc || image?.src || '';
  };

  const replaceCartCount = (cartIcon, markup) => {
    cartIcon.querySelector('.cart-count-bubble')?.remove();
    if (markup) cartIcon.insertAdjacentHTML('beforeend', markup);
  };

  const holdCartCount = (cartIcon, previousMarkup) => {
    const state = { nextMarkup: null, released: false };
    state.observer = new MutationObserver(() => {
      if (state.released) return;

      const nextMarkup = cartIcon.querySelector('.cart-count-bubble')?.outerHTML || '';
      if (nextMarkup === previousMarkup) return;

      state.nextMarkup = nextMarkup;
      state.observer.disconnect();
      replaceCartCount(cartIcon, previousMarkup);
    });
    state.observer.observe(cartIcon, { childList: true, subtree: true });

    return state;
  };

  const releaseCartCount = (state) => {
    state.released = true;
    state.observer.disconnect();
    if (state.nextMarkup === null) return;

    const currentCartIcon = document.querySelector('#cart-icon-bubble');
    if (currentCartIcon) replaceCartCount(currentCartIcon, state.nextMarkup);
  };

  const animateToCart = ({ button, imageUrl, quantity, previousCountMarkup }) => {
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (!button?.isConnected || !cartIcon || !imageUrl) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const countHold = holdCartCount(cartIcon, previousCountMarkup);
    const flyerCount = Math.min(Math.max(Number.parseInt(quantity, 10) || 1, 1), 12);
    const buttonRect = button.getBoundingClientRect();
    const cartRect = cartIcon.getBoundingClientRect();
    const imageSize = Math.min(110, Math.max(72, buttonRect.height * 1.65));
    const startX = buttonRect.left + buttonRect.width / 2 - imageSize / 2;
    const startY = buttonRect.top + buttonRect.height / 2 - imageSize / 2;
    const endX = cartRect.left + cartRect.width / 2 - imageSize / 2;
    const endY = cartRect.top + cartRect.height / 2 - imageSize / 2;
    const deltaX = endX - startX;
    const deltaY = endY - startY;
    const arcHeight = Math.min(180, Math.max(80, Math.abs(deltaY) * 0.28));

    const flights = Array.from({ length: flyerCount }, (_, index) => {
      const flyer = document.createElement('img');
      const direction = index % 2 === 0 ? -1 : 1;
      const pathSpread = direction * Math.min(54, 12 + index * 7);
      const individualArc = arcHeight + (index % 3) * 18;
      const startRotation = -10 + index * 4;
      const endRotation = direction * (14 + index * 2);

      flyer.className = 'coverax-cart-fly';
      flyer.src = imageUrl;
      flyer.alt = '';
      flyer.setAttribute('aria-hidden', 'true');
      flyer.style.setProperty('--cart-fly-size', `${imageSize}px`);
      flyer.style.left = `${startX}px`;
      flyer.style.top = `${startY}px`;
      document.body.appendChild(flyer);

      const flight = flyer.animate(
        [
          {
            transform: `translate3d(0, 0, 0) scale(0.08) rotate(${startRotation}deg)`,
            opacity: 0,
          },
          {
            transform: `translate3d(${pathSpread * 0.2}px, -20px, 0) scale(1.08) rotate(${direction * 3}deg)`,
            opacity: 1,
            offset: 0.18,
          },
          {
            transform: `translate3d(${deltaX * 0.48 + pathSpread}px, ${
              deltaY * 0.48 - individualArc
            }px, 0) scale(0.82) rotate(${direction * 8}deg)`,
            opacity: 1,
            offset: 0.58,
          },
          {
            transform: `translate3d(${deltaX}px, ${deltaY}px, 0) scale(0.16) rotate(${endRotation}deg)`,
            opacity: 0.45,
          },
        ],
        {
          duration: 1250,
          delay: index * 115,
          easing: 'cubic-bezier(0.22, 0.8, 0.3, 1)',
          fill: 'forwards',
        }
      );

      return flight.finished.finally(() => flyer.remove());
    });

    Promise.allSettled(flights).then(() => {
      releaseCartCount(countHold);
      const currentCartIcon = document.querySelector('#cart-icon-bubble');
      if (!currentCartIcon) return;

      currentCartIcon.classList.remove('coverax-cart-fly__target');
      void currentCartIcon.offsetWidth;
      currentCartIcon.classList.add('coverax-cart-fly__target');
      window.setTimeout(() => currentCartIcon.classList.remove('coverax-cart-fly__target'), 480);
    });
  };

  document.addEventListener(
    'submit',
    (event) => {
      const pdpForm = event.target.closest('coverax-pdp form[data-type="add-to-cart-form"]');
      const popupForm = event.target.closest('.cart-popup-card form[data-type="add-to-cart-form"]');
      const form = pdpForm || popupForm;
      if (!form) return;

      const formData = new FormData(form);
      pendingFlight = {
        button: form.querySelector('[name="add"]'),
        imageUrl: pdpForm
          ? getVariantImage(pdpForm.closest('coverax-pdp'))
          : getPopupImage(form),
        previousCountMarkup: document.querySelector('#cart-icon-bubble .cart-count-bubble')?.outerHTML || '',
        quantity: formData.get('quantity'),
        variantId: String(formData.get('id') || ''),
      };
    },
    true
  );

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event.source !== 'product-form' || !pendingFlight) return;

    const flight = pendingFlight;
    pendingFlight = null;
    if (flight.variantId !== String(event.productVariantId || '')) return;
    if (!flight.imageUrl) {
      flight.imageUrl = event.cartData?.featured_image?.url || '';
    }
    animateToCart(flight);
  });

  subscribe(PUB_SUB_EVENTS.cartError, (event) => {
    if (event.source === 'product-form') pendingFlight = null;
  });
})();
